// extracted by mini-css-extract-plugin
export default {"list-title":"MovieRow_list-title__EfkEp","movies-row":"MovieRow_movies-row__Aa7Ra"};